import '../styles/dd-messages.css';

class DragAndDropMessages {
  constructor(jotformImage, editorContainerId) {
    this.jotformImage = jotformImage;
    this.editorContainerId = editorContainerId;
  }

  init() {
    this.dragNoticeEl = this.renderDragNoticeEl();
    this.bindEvents();
  }

  bindEvents() {
    const editorContainerEl = document.querySelector(this.editorContainerId);
    document.addEventListener('dragover', e => this.handleDragOver(e));
    document.addEventListener('dragleave', () => this.handleDragLeave());
    document.addEventListener('drop', e => this.handleDrop(e));

    editorContainerEl.addEventListener('dragover', () => {
      this.insideEditor = true;
    });
    editorContainerEl.addEventListener('dragleave', () => {
      this.insideEditor = false;
    });
  }

  handleDragOver(e) {
    e.preventDefault();
    if (this.jotformImage.modalActive) return;

    this.dragNoticeEl.setAttribute('data-state', 'show');
    this.dragNoticeEl.setAttribute('data-position', this.insideEditor ? 'inside' : 'outside');
  }

  handleDragLeave() {
    this.dragNoticeEl.removeAttribute('data-position');
    this.dragNoticeEl.removeAttribute('data-state');
  }

  handleDrop(e) {
    e.preventDefault();

    const DROPPED_OUTSIDE_MESSAGE_DURATION = 1500;
    const REMOVE_NOTRANSITION_DELAY = 10;

    if (this.insideEditor) {
      this.dragNoticeEl.removeAttribute('data-state');
      this.dragNoticeEl.removeAttribute('data-position');
    } else {
      this.dragNoticeEl.setAttribute('data-transition', 'notransition');
      this.dragNoticeEl.setAttribute('data-position', 'dropped-outside');
      this.dragNoticeEl.textContent = 'Please drop the image over the text editor';
      setTimeout(() => {
        this.dragNoticeEl.removeAttribute('data-state');
        this.dragNoticeEl.removeAttribute('data-position');
        this.dragNoticeEl.textContent = 'Drop images here';
      }, DROPPED_OUTSIDE_MESSAGE_DURATION);
      setTimeout(() => {
        this.dragNoticeEl.removeAttribute('data-transition');
      }, DROPPED_OUTSIDE_MESSAGE_DURATION + REMOVE_NOTRANSITION_DELAY);
    }
  }

  renderDragNoticeEl() {
    let dragNoticeEl = document.querySelector('.ql-drag-notice');
    if (!dragNoticeEl) {
      dragNoticeEl = document.createElement('div');
      dragNoticeEl.textContent = 'Drop images here';
      dragNoticeEl.classList.add('ql-drag-notice');
      document.querySelector(this.editorContainerId)
        .appendChild(dragNoticeEl);
    }
    return dragNoticeEl;
  }
}

export default DragAndDropMessages;
